export const formatWebsiteThematic = (item) => {
  if (item == null) return '';
  if (typeof item === 'string') return item.trim();
  if (typeof item === 'object') {
    return String(item.thematic || item.name || item.label || '').trim();
  }
  return '';
};

export const formatWebsiteThematicsService = (website) => {
  const thematics = website?.thematics;
  if (!Array.isArray(thematics) || thematics.length === 0) return '';
  const labels = thematics.map(formatWebsiteThematic).filter(Boolean);
  return Array.from(new Set(labels)).join(',');
};
